import colors from 'styles/colors'
import InCardStack from './container/InCardStack'
import { Box, LinearProgress, Typography } from '@mui/material'
import HikingIcon from '@mui/icons-material/Hiking'
import { IconContainer } from './Icons'

const LinearProgressBar = ({
  value,
  label,
  labelSx,
  barSx = {},
  width = 150,
  showProgressIcon = false
}) => {
  const ProgressIcon = () => (
    <Box
      sx={{
        position: 'absolute',
        top: -16,
        left: `calc(${value}% - ${value > 5 ? 30 : 5}px)`,
        transition: 'left 0.3s ease-in-out',
        zIndex: 1
      }}
      style={{
        margin: 0
      }}>
      <Box
        sx={{
          width: 32,
          padding: 2,
          borderRadius: 1,
          backgroundColor: colors.GoldenYellow50,
          boxShadow: '0px 3px 10px 0px rgba(0, 0, 0, 0.20)',
          display: 'flex',
          justifyContent: 'center'
        }}>
        <IconContainer icon={<HikingIcon />} />
      </Box>
      <Box
        sx={{
          width: 0,
          height: 0,
          borderLeft: `6px solid ${colors.Transparent}`,
          borderRight: `6px solid ${colors.Transparent}`,
          borderTop: `6px solid ${colors.GoldenYellow50}`,
          margin: '0 auto'
        }}
      />
    </Box>
  )

  return (
    <InCardStack spacing={4} sx={{ position: 'relative', width: '100%' }}>
      {showProgressIcon && <ProgressIcon />}
      <LinearProgress
        variant='determinate'
        value={value}
        sx={{
          width,
          height: 8,
          backgroundColor: colors.Grey100,
          ...barSx
        }}
      />
      {label && (
        <Typography
          maxWidth={width}
          textAlign='center'
          variant='body1Small'
          color={colors.Grey350}
          sx={labelSx}>
          {label}
        </Typography>
      )}
    </InCardStack>
  )
}

export default LinearProgressBar
